<template>
  <v-row>
    <v-col cols="12">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
        :retain-focus="false"
      >
        <v-card>
          <v-form ref="form" lazy-validation>
            <v-card-title>
              <span>Images</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" class="mt-0 pt-0">
                    <v-file-input
                      small-chips
                      truncate-length="15"
                      prepend-icon=""
                      append-icon="mdi-image"
                      label="Select Image(s) *"
                      show-size
                      accept="image/*"
                      multiple
                      :rules="rules.required"
                      v-model="form.files"
                    ></v-file-input>
                  </v-col>

                  <!-- <v-col cols="12" class="mt-0 pt-0">
                    <v-text-field
                      type="date"
                      name="transactionDate"
                      v-model="form.transactionDate"
                      label="Transaction Date"
                      :rules="rules.required"
                    />
                  </v-col> -->
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-text>
              <v-data-table
                :headers="table.headers"
                :items="table.data"
                :items-per-page="10"
                :loading="table.loading"
                item-key="id"
                loading-text="Loading... Please wait"
                class="elevation-1"
              >
                <template
                  v-for="header in table.headers.filter((header) =>
                    header.hasOwnProperty('formatter')
                  )"
                  v-slot:[`item.${header.value}`]="{ value }"
                >
                  {{ header.formatter(value) }}
                </template>

                <template v-slot:[`item.publicPath`]="{ item }">
                  <div class="py-1 images" v-viewer>
                    <img :src="item.publicPath" height="100" />
                    <!-- <v-img
                      :src="item.publicPath"
                      aspect-ratio="1"
                      max-height="100"
                      contain
                      elevation-1
                    ></v-img> -->
                  </div>
                </template>
              </v-data-table>
            </v-card-text>
            <v-card-actions class="pb-5">
              <v-spacer></v-spacer>
              <v-btn :disabled="loadingBtn" @click.native="cancel">
                Close
              </v-btn>
              <v-btn
                color="primary"
                :loading="loadingBtn"
                :disabled="loadingBtn"
                @click.prevent="onSubmit()"
                class="px-10"
              >
                Save
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <!-- <Snackbar></Snackbar> -->
    </v-col>
  </v-row>
</template>

<script>
import moment from "moment";
import ShareableMethods from "@/mixins/ShareableMethods";

export default {
  mixins: [ShareableMethods],
  name: "TransactionImagesDialogv2",
  data() {
    return {
      dialog: false,
      resolve: null,
      reject: null,

      selectedData: null,

      loadingBtn: false,
      rules: {
        required: [(value) => !!value || "Required."],
      },
      form: {
        // transactionDate: "",
        files: null,
      },

      table: {
        sortDesc: true,
        loading: false,

        headers: [
          {
            text: "Image",
            align: "start",
            value: "publicPath",
          },

          {
            text: "Uploaded Date",
            align: "start",
            value: "createdDate",
            formatter: (x) => (x ? moment(x).format("MMM DD, YYYY") : null),
          },
        ],
        data: [],
      },
    };
  },

  methods: {
    open(data) {
      this.dialog = true;

      // console.log(data.dateLabel);
      // console.log(data.retailerId);
      this.selectedData = data;
      this.getPhotos(data.retailerId, data.dateLabel);

      // this.options = Object.assign(this.options, options);
      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    async onSubmit() {
      if (!this.$refs.form.validate()) {
        return false;
      }

      this.loadingBtn = true;
      let formData = new FormData();

      // files
      for (let [i, file] of this.form.files.entries()) {
        formData.append(`photo${i}`, file, file.name);
      }

      formData.append("transactionDate", this.selectedData.dateLabel);
      formData.append("retailerId", this.selectedData.retailerId);
      await this.$api
        .post("/retailer-transactions/upload", formData)
        .then((response) => {
          const res = response.data;

          if (!res.status) {
            this.loadingBtn = false;
            return;
          }

          // this.$emit("response", true);
          this.getPhotos(
            this.selectedData.retailerId,
            this.selectedData.dateLabel
          );
          this.loadingBtn = false;
          this.$refs.form.reset();
          this.$store.dispatch(
            "addSnackbarMessage",
            "Image is successfully saved."
          );
          this.$store.dispatch("addSnackbar", true);
        })
        .catch((e) => {
          console.log(e);
          this.loadingBtn = false;
        });
    },

    async getPhotos(retailerId, transactionDate) {
      this.table.loading = true;
      await this.$api
        .get(
          `/retailer-transactions/upload?retailerId=${retailerId}&transactionDate=${transactionDate}`
        )
        .then((response) => {
          this.table.loading = false;
          const newArr = response.data.data;
          this.table.data = newArr.retailersTransactionsUpload;
          // console.log(newArr.retailersTransactionsUpload);

          // this.$nextTick(() => {

          // });
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },
    agree() {
      this.resolve(true);
      this.dialog = false;
    },
    cancel() {
      this.resolve(false);
      this.dialog = false;
    },
  },
};
</script>

<style scoped>
.images > img {
  cursor: pointer;
}
</style>
